module.exports = {
  type: 'attachments',
  id: 'scans',
  icon: 'paperclip',
  title: {
    de: 'Datenbereitstellung',
    en: 'Data upload'
  },
  introOff: {
    style: 'info',
    icon: 'fas fa-info',
    de: 'Wenn die Option "Ich möchte 3D-Modelle versenden" gewählt wurde, wird kein Upload benötigt',
    en: 'No upload is required if you select option "3D model"'
  },
  form: [{
    id: 'modelType',
    type: 'radio',
    required: true,
    label: {
      de: 'Modelle',
      en: 'Models'
    },
    options: [{
        value: 'nomodels',
        label: {
          de: 'Bitte keine Modelle aus dem Scan herstellen',
          en: 'Do not produce models from the scan'
        },
        /*info: {
          de: 'Ein Abholauftrag wird bei der Bestellung automatisch an UPS übermittelt',
          en: 'We will automatically place an order at UPS to pick up your parcel'
        }*/
      },
      {
        value: 'models',
        label: {
          de: 'Bitte 3D-Modelle zum Auftrag produzieren',
          en: 'Produce 3D models for this order'
        },
        /*info: {
          de: 'Ein Abholauftrag wird bei der Bestellung automatisch an UPS übermittelt',
          en: 'We will automatically place an order at UPS to pick up your parcel'
        },*/
        itemnum: 'CS463',
      }
    ]
  }, ],

  // Global settings and restrictions
  fileTypes: null, // Everything is permitted
  sizeLimit: null, // Size limit in MB
  fileLimit: null, // No upload limit

  classes: {
    scans: {
      fileTypes: ['.stl', '.zip'],
      fileLimit: null,
      requires: 1, // 1 file is required
      secure: true,
      title: {
        de: 'Digitale Modelldaten',
        en: 'Digital model data'
      },
      placeholder: {
        de: 'Scan-Upload',
        en: 'Scan-Upload'
      }
    }
  }
}
